import { Component, Inject, OnInit } from '@angular/core';
import { ModalRef, MODAL_DATA_VAR } from "mis-crystal-design-system/modal";
import { IDatePickerConfig } from 'mis-crystal-design-system/datepicker_v2';
import { DropdownItem } from "mis-crystal-design-system/dropdown";
import { CommonService } from '../../services/common.service';
import { CommonCabService } from '../../../trip-view-cab/services/common-cab.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { catchError, concatMap, of } from 'rxjs';
import { DateUtils } from 'src/app/utils/days-utils';
import { DatePipe } from '@angular/common';
import { ToastService } from 'mis-crystal-design-system/toast';
@Component({
  selector: 'app-device-health',
  templateUrl: './device-health.component.html',
  styleUrls: ['./device-health.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DeviceHealthComponent implements OnInit {
  imgSrc: string;
  service: any
  columnsToDisplay = ["Expand",
    "Time",
    "App",
    "Log Type",
    "Details"];

  options = {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  };


  //  const formattedTime = epoxyTime.toLocaleString('en-US', options);


  constructor(public modalRef: ModalRef,
    @Inject(MODAL_DATA_VAR) data: any, private commonService: CommonService, commonCabService: CommonCabService, private datePipe: DatePipe, private envService: EnvironmentService,private toast:ToastService) {

    if (data.type === 'SHUTTLE') {
      this.service = commonService; // Assign  CommonService
    } else {
      this.service = commonCabService // Assign  CommonCabService
    }
    console.log("data of intial ", data);
  }


  deviceId: any
  imei: any
  loader: boolean = true
  currentDate = DateUtils.formatCurrentDate('MMM DD, YYYY');
  selectedDate = this.currentDate

  logTypeDropdown: DropdownItem[] = [{ label: 'All', value: '-1' }, { label: 'Sms', value: '1' }, { label: 'Call', value: '2' }, { label: 'Internet', value: '3' }, { label: 'Power Management', value: '4' }, { label: 'Duty', value: '5' }, { label: 'Geofence', value: '6' }, { label: 'Gps', value: '7' }, { label: 'Crash', value: '8' }]

  selectedLogType: DropdownItem = { label: '', value: '' };
  response: any
  device_health_column =
    [
      "Expand",
      "Time",
      "App",
      "Log Type",
      "Details"
    ]
  device_health_list =
    [
      {
        'Time': '18th Aug 22, 13:14 PM',
        'App': 'Bussiness',
        'LogType': 'Duty',
        'Details': ''
      }
    ]


  startDatepickerConfig: Partial<IDatePickerConfig> = {
    maxDate: DateUtils.formatCurrentDate('MMM DD, YYYY'),
    format: 'MMM DD, YYYY',
  };
  page = 1;
  pageSize = 10;
  tempResponse: any
  filterResponse: any
  dataSource = [];
  deviceVersion:string = ''
  subVersions:any[]
  isReleaseNotesPresent:boolean = false;
  releaseNotesVersion:any;


  ngOnInit(): void {
    this.imgSrc = this.envService.getImgSrc();
    this.deviceId = this.service.response?.tripDetails?.vehicle?.deviceDTO?.deviceId
    this.imei = this.service.response?.tripDetails?.vehicle?.deviceDTO?.imei
    this.selectedLogType = this.logTypeDropdown[0];
    this.selectedDate = this.service.response?.tripDetails?.plannedStartTime
          ? DateUtils.formatDate(this.service.response.tripDetails.plannedStartTime, 'MMM DD, YYYY')
          : this.selectedDate;
    this.commonService.getDeviceHealth(this.selectedDate, this.deviceId, this.imei).subscribe((res: any) => {
      this.response = res
      if (this.response) {
        this.tempResponse = this.response;



        this.filterResponse = this.tempResponse

        this.dataSource = this.tempResponse.map(v => ({ ...v, expanded: false }));
        //  this.dataSource=this.dataSource.map
        console.log('temp', this.dataSource);

      }
      this.loader = false
    })

    this.getDeviceVersionDetails();

  }

  private getDeviceVersionDetails(){

    this.commonService.getReleaseNotesData().pipe(
      concatMap((res: any) => {
        this.subVersions = this.getSubVersionDetails(res);
        return this.commonService.getDeviceInfo();
      }),
      catchError((error) => {
        console.error('Error occurred during API calls:', error);
        // this.loader = false; 
        return of(null);
      })
    ).subscribe({
      next: (deviceInfo: any) => {
        if (!deviceInfo) {
          console.log('No device info found due to API error');
          return;
        }
        this.deviceVersion = deviceInfo.deviceVersion;
        const versionInReleaseNotes = this.subVersions?.find((version: any) =>
          version.name === this.deviceVersion
        );
  
        if (versionInReleaseNotes && 'name' in versionInReleaseNotes) {
          this.releaseNotesVersion = versionInReleaseNotes
          this.isReleaseNotesPresent = true;
        }
        // this.loader = false;
      },
      error: (err: any) => {
        console.error('An unexpected error occurred:', err);
        // this.loader = false; 
      },
      complete: () => {
        // this.loader = false; 
      }
    });
  }

  private getSubVersionDetails(res: any) {
    return (res.children || []).flatMap((version: any) => 
        (version.children || []).length ? [{ name: version.name, url: version.children[0]?.url }] : []
    );
  }

  openReleaseNotes(){
      if(this.releaseNotesVersion?.url){
      window.open(this.releaseNotesVersion.url , '_blank')
    }else{
      this.toast.displayMsg('Release notes URL not found for device version: ' + this.deviceVersion);
    }
  }

  toggleRow(element) {
    // Uncommnet to open only single row at once
    // ELEMENT_DATA.forEach(row => {
    //   row.expanded = false;
    // })
    element.expanded = !element.expanded


  }



  loadMore() {
    this.page++;
    this.tempResponse = [...this.tempResponse, ...this.response.slice(this.page * this.pageSize, (this.page + 1) * this.pageSize)];
    this.filterResponse = this.tempResponse
    console.log("temp response", this.tempResponse.length, this.tempResponse);
  }


  filterTable(logType: any) {
    // Filter the data based on the log type
    if (logType == -1) {
      this.filterResponse = this.tempResponse
      return this.filterResponse
    }
    const temporary = this.tempResponse
    this.filterResponse = temporary.filter((item: any) => item.logType == logType);

    // Map the log type to its corresponding string representation
    // const mappedData = this.filterResponse.map((item: any) => {
    //   switch (item.logType) {
    //     case 1:
    //       item.logTypeString = "Sms";
    //       break;
    //     case 2:
    //       item.logTypeString = "Call";
    //       break;
    //     case 3:
    //       item.logTypeString = "Internet";
    //       break;
    //     case 4:
    //       item.logTypeString = "Power Management";
    //       break;
    //     case 5:
    //       item.logTypeString = "Duty";
    //       break;
    //     case 6:
    //       item.logTypeString = "Geofence";
    //       break;
    //     case 7:
    //       item.logTypeString = "Gps";
    //       break;
    //     case 8:
    //       item.logTypeString = "Code Screw";
    //       break;
    //     case 9:
    //       item.logTypeString = "Start Stop";
    //       break;
    //     case 10:
    //       item.logTypeString = "Security";
    //       break;
    //   }
    //   return item;
    // });
    // // Assign the filtered and mapped data to the component property
    // this.filterResponse = mappedData;
  }


  changeFormat1(a: any) {
    this.selectedDate = a
    this.loader = true
    this.commonService.getDeviceHealth(a, this.deviceId, this.imei).subscribe((res: any) => {

      this.response = res
      if (this.response) {
        // this.tempResponse = this.response.slice(0, this.pageSize);
        this.filterResponse = this.response
      }
      this.loader = false
    })
    this.selectedLogType = this.logTypeDropdown[0]
  }

  selectDutyType(event: DropdownItem) {
    console.log("event", event);

    this.selectedLogType = event
    this.filterTable(event.value)
  }

  closeModal() {
    this.modalRef.close();
  }


  getLogTypeText(logType: any) {
    switch (logType) {
      case 1:
        return "Sms";
        break;
      case 2:
        return "Call";
        break;
      case 3:
        return "Internet";
        break;
      case 4:
        return "Power Management";
        break;
      case 5:
        return "Duty";
        break;
      case 6:
        return "Geofence";
        break;
      case 7:
        return "Gps";
        break;
      case 8:
        return "Code Screw";
        break;
      case 9:
        return "Start Stop";
        break;
      case 10:
        return "Security";
        break;

      default:
        return "";
        break;
    }
  }

  changeDateFormat(ep) {
    return DateUtils.formatDateTime(ep, 'MMM Do YY, HH:mm');

  }

}




// var propertyName = appType=="1"?"Platform":"Business";